<template>
  <div>
    <el-form class="demo-form-inline">
      <el-form-item>
        <el-button type="success" @click="addtype">新增类型</el-button>
      </el-form-item>
      <el-form-item label="类型展示">
        <!--class="flex-wrap-container" <span v-for="i in optionschannel" :key="i.type" class="flex-wrap-item">{{ i.name }}</span> -->
        <el-table
          :data="optionschannel"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="type"
            label="id"
            width="180"
          />
          <el-table-column
            prop="name"
            label="名称"
            width="290"
          />
        </el-table>

      </el-form-item>
    </el-form>
    <el-dialog
      title="添加类型"
      :visible.sync="typedialogVisible"
      width="40%"
      append-to-body
      @close="type_name = ''"
    >
      <div style="display: flex;">
        <el-input v-model.trim="type_name" type="text" />
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <pagination-right
      :total="totals"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div></template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'

import { feishuChatGetErrorTypeList, feishuChatAddType } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      page: {
        page: 1,
        page_size: 10
      },
      type_name: '',
      formInline: {
        name: ''
      },
      optionschannel: [],
      typedialogVisible: false,
      totals: 0
    }
  },
  mounted() {
    this.channelShow()
  },
  methods: {
    addtype() {
      this.typedialogVisible = true
    },
    async submit() {
      if (this.type_name === '') {
        this.$message({
          type: 'error',
          message: '请选择类型'
        })
        return
      }
      await feishuChatAddType({
        type_name: this.type_name
      })
      this.channelShow()
      this.typedialogVisible = false
      this.type_name = ''
      this.$message({
        type: 'success',
        message: '类型添加成功!'
      })
    },
    suanee() {

    },
    async channelShow() {
      this.optionschannel = []
      const data = {
        name: this.formInline.name,
        ...this.page
      }
      const datas = await feishuChatGetErrorTypeList(data)
      this.totals = datas.data.total
      this.optionschannel = datas.data.list
      console.log(this.totals, '   this.total ')
    },
    // 分页
    fetchPageSize(e) {
      this.page.page_size = e
      this.channelShow()
    },
    fetchCurrentPage(e) {
      this.page.page = e
      this.channelShow()
    }

  }
}
</script>

<style>

</style>
